import { Injectable } from '@angular/core';
import { Subscription, gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class MessageGQLService extends Subscription {
  document = gql`
    subscription onNotifyMessageDirect($recipientIds: [Int]) {
      onNotifyMessageDirect(recipientIds: $recipientIds) {
        sentAt
        message
        messageId
        recipientId
        recipientEmail
        senderId
        senderEmail
      }
    }
  `;
}
